import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "reactstrap";
import { fetchChatFile } from "../../helpers/chat_helper";

// Хавсралтыг харуулах нэгж.
//
// ⚠️ Файл нь СТАТИК замаар үйлчлэгддэггүй — эрх шалгадаг маршрутаас ирдэг тул
// `<img src="...">` шууд ажиллахгүй (браузер тэнд токен явуулж чадахгүй).
// Тиймээс blob-оор татаж, object URL үүсгэнэ.

export const humanSize = (n) => {
  if (!n) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

// Өргөтгөлөөр icon сонгоно
const iconOf = (name, mime) => {
  const e = String(name || "").split(".").pop().toLowerCase();
  if (/pdf/.test(e) || /pdf/.test(mime || "")) return "ri-file-pdf-line text-danger";
  if (/^(doc|docx|rtf|odt)$/.test(e)) return "ri-file-word-line text-primary";
  if (/^(xls|xlsx|csv|ods)$/.test(e)) return "ri-file-excel-line text-success";
  if (/^(ppt|pptx|odp)$/.test(e)) return "ri-file-ppt-line text-warning";
  if (/^(zip|rar|7z|tar|gz)$/.test(e)) return "ri-file-zip-line text-secondary";
  if (/^(mp3|wav|ogg|m4a|flac)$/.test(e)) return "ri-file-music-line text-info";
  if (/^(mp4|mov|avi|mkv|webm)$/.test(e)) return "ri-file-video-line text-info";
  if (/^(txt|md|log)$/.test(e)) return "ri-file-text-line text-muted";
  return "ri-file-3-line text-muted";
};

const ChatAttachment = ({ att, onPreview }) => {
  // `localUrl` — илгээгчийн ӨӨРИЙН сонгосон файлаас шууд үүсгэсэн URL.
  // Байвал сервэрээс blob-оор дахин татах шаардлагагүй: илгээмэгц харагдана.
  const [url, setUrl] = useState(att.localUrl || null);
  const [failed, setFailed] = useState(false);
  const urlRef = useRef(null);

  // Зургийг л урьдчилан татна. Бусад файлыг дарсан үед л татаж, санах ойг гамнана.
  useEffect(() => {
    let dead = false;
    if (att.kind !== "image") return undefined;
    if (att.localUrl) { setUrl(att.localUrl); return undefined; }
    if (!att.url) return undefined;
    (async () => {
      try {
        const blob = await fetchChatFile(att.url);
        if (dead) return;
        const u = URL.createObjectURL(blob);
        urlRef.current = u;
        setUrl(u);
      } catch (e) {
        if (!dead) setFailed(true);
      }
    })();
    return () => {
      dead = true;
      if (urlRef.current) URL.revokeObjectURL(urlRef.current);
    };
  }, [att.url, att.kind, att.localUrl]);

  const download = async () => {
    if (!att.url) return;                 // хараахан илгээгдээгүй
    try {
      const blob = await fetchChatFile(att.url);
      const u = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = u;
      a.download = att.name || "file";
      document.body.appendChild(a);
      a.click();
      a.remove();
      // Татаж эхлэхэд зай гаргаж өгөөд чөлөөлнө
      setTimeout(() => URL.revokeObjectURL(u), 10000);
    } catch (e) {
      setFailed(true);
    }
  };

  if (att.kind === "image") {
    return (
      <div className="mt-1">
        {failed ? (
          <div className="d-flex align-items-center gap-1 fs-12 text-danger">
            <i className="ri-image-off-line"></i> Зураг ачаалагдсангүй
          </div>
        ) : url ? (
          <img
            src={url}
            alt={att.name}
            role="button"
            onClick={() => onPreview && onPreview({ ...att, objectUrl: url })}
            className="rounded"
            style={{ maxWidth: "100%", maxHeight: 220, objectFit: "cover", display: "block" }}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center rounded bg-light"
            style={{ width: 160, height: 100 }}>
            <Spinner size="sm" />
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      role="button"
      onClick={download}
      className="d-flex align-items-center gap-2 mt-1 p-2 rounded border bg-body text-body"
      style={{ maxWidth: 260 }}
    >
      <i className={`${iconOf(att.name, att.mime)} fs-24 flex-shrink-0`}></i>
      <div className="min-w-0 flex-grow-1">
        <div className="text-truncate fs-12 fw-medium">{att.name || "файл"}</div>
        <div className="text-muted fs-11">
          {failed ? <span className="text-danger">татагдсангүй</span> : humanSize(att.size)}
        </div>
      </div>
      <i className="ri-download-2-line text-muted flex-shrink-0"></i>
    </div>
  );
};

export default ChatAttachment;
